import React, { Component } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Icon,
  Tooltip,
  Popconfirm,
  Switch,
  Empty
} from "antd";
import moment from "moment";
import styles from "./leaveWordList.less";
import tianjiaChecked from "../images/kejian_p.png";
import deleteImg from "../images/delete_n.png";
import tianjia from "../images/kejian_n.png";
import huifu from "../images/huifu_n.png";
import empty from "../images/empty_n_pc.png";

const text = "删除后无法恢复，确定删除该留言吗？";
export default class LeaveWordList extends Component {
  changeCanLeave = checked => {
    const { changeCanLeave } = this.props;
    changeCanLeave(checked);
  };

  renderLeaveWordItem = (item, isAudit) => {
    let { subLeaveWords = [] } = item;
    if (subLeaveWords === null) {
      subLeaveWords = [];
    }
    const { changeAudit, addReply, deleteLeaveWord } = this.props;
    return (
      <div className={styles.leaveWordItem} key={item.id}>
        <div className="item">
          <div className="leave_person">
            <span>游客</span>
            <div>
              <div className="name">游客</div>
              <p className="desc">
                {decodeURIComponent(decodeURIComponent(item.msg))}
              </p>
              <span className="time">
                {moment(item.gmtCreate).format("YYYY.MM.DD HH:mm")}
              </span>
            </div>
          </div>
          <div className="opreation_item">
            {!!subLeaveWords.length && <span />}
            <span>
              {isAudit === 1 && (
                <img
                  src={item.isAudit === 1 ? tianjiaChecked : tianjia}
                  onClick={() => changeAudit(item)}
                  alt=""
                  className="show"
                />
              )}
            </span>
            {!subLeaveWords.length && (
              <span>
                <img
                  src={huifu}
                  onClick={() => addReply(item)}
                  alt=""
                  className="return"
                />
              </span>
            )}
            <span style={{ marginRight: 10 }}>
              <Popconfirm
                placement="topRight"
                arrowPointAtCenter
                title={text}
                onConfirm={() => deleteLeaveWord(item)}
              >
                <img src={deleteImg} alt="" className="delete" />
              </Popconfirm>
            </span>
          </div>
        </div>
        {!!subLeaveWords.length && this.renderReply(subLeaveWords[0])}
        {!subLeaveWords.length && item.checked && this.renderReplyInput(item)}
      </div>
    );
  };

  renderReply = item => {
    const { deleteLeaveWord } = this.props;
    return (
      <Row className={styles.replyContent}>
        <Col span={19}>
          <div className={styles.reply}>
            <div>
              <i />
              管理员的回复
            </div>
            <div>{decodeURIComponent(decodeURIComponent(item.msg))}</div>
          </div>
        </Col>
        <Col span={5}>
          <div>
            <span />
            <span />
            <span style={{marginRight:8}}>
              <Popconfirm
                placement="topRight"
                arrowPointAtCenter
                title={text}
                onConfirm={() => deleteLeaveWord(item)}
              >
                <img src={deleteImg} alt="" />
              </Popconfirm>
            </span>
          </div>
        </Col>
      </Row>
    );
  };

  renderReplyInput = item => {
    const { saveLeaveWord, addReply, changeReplyContent } = this.props;
    return (
      <div className={styles.inputArea}>
        <div className="title">回复该留言</div>
        <Input.TextArea
          placeholder="请输入文字"
          rows={8}
          maxLength={500}
          onChange={e => changeReplyContent(e)}
        />
        <div className="buttonArea">
          <Button type="primary" onClick={() => saveLeaveWord(item)}>
            发送
          </Button>
          <Button type="ghost" onClick={() => addReply(item)}>
            取消
          </Button>
        </div>
      </div>
    );
  };

  renderTooltip = isAudit => {
    return (
      <div className={styles.myTooltip}>
        {isAudit === 1 && (
          <div className="item">
            <img src={tianjia} className="hasTop" alt="" />
            <span>将该条留言增加至留言区，所有人可见</span>
          </div>
        )}

        <div className="item">
          <img src={huifu} alt="" />
          <span>回复留言者</span>
        </div>
        <div className="item">
          <img src={deleteImg} alt="" />
          <span>删除该条留言</span>
        </div>
      </div>
    );
  };

  render() {
    const { leaveWordListData, isAudit, noData, nowItem = [] } = this.props;
    return (
      <div className={styles.leaveWordList}>
        <Row className="top" style={{ textAlign: "right" }}>
          {nowItem.canLeaveWords ? (
            ""
          ) : (
            <span className="cantLeave">
              当前文章暂未开启留言功能，右侧开启
            </span>
          )}
          留言{" "}
          <Switch
            onChange={this.changeCanLeave}
            checked={nowItem.canLeaveWords}
          />
        </Row>
        <Row className="header">
          <Col span={19}>全部留言</Col>
          <Col span={5}>
            操作
            <Tooltip
              title={this.renderTooltip(isAudit)}
              placement="topLeft"
              arrowPointAtCenter
            >
              <Icon type="info-circle-o" />
            </Tooltip>
          </Col>
        </Row>
        {leaveWordListData.length === 0 && (
          <Empty image={empty} description="暂无留言" />
        )}
        {(leaveWordListData || []).map(item => {
          return this.renderLeaveWordItem(item, isAudit);
        })}
      </div>
    );
  }
}
